import React, { useEffect } from "react";
import * as bootstrap from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const ThankYou = (props) => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  return (
    <div className="text-center">
      <bootstrap.Container>
        <bootstrap.Row>
          <bootstrap.Col>
            <h2 className="fw-bold py-4">
              Thank you for submitting your information for the Cyme Tech Murphy
              Bed recall
            </h2>
            <bootstrap.Card>
              <bootstrap.Card.Body>
                <p className="lead py-2">
                  Your registration ID is {location.state.id}
                </p>
                <p className="lead py-2">
                  You will receive an email shorty confirming that your record
                  has been received. The email will include details about your
                  registration and next steps.
                </p>
                <p className="lead py-2">
                  You should immediately stop using the Murphy bed and ensure
                  that the chain lock is fully engaged with the bed until we
                  have completed the inspection and repair of your bed.
                </p>
              </bootstrap.Card.Body>
            </bootstrap.Card>
          </bootstrap.Col>
        </bootstrap.Row>
      </bootstrap.Container>
    </div>
  );
};
